// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardReport_container__2eNUt"};